import { type TInsurancesResponse } from '@/types/insuranceMapper';
import { type GetInsurancesByParamsFilters } from '@/types/insuranseServer';
import { type TOnlineRequest, type TRequest } from '@/types/request';
import { type TUserUpdateDto } from '@/types/user';

import { ApiConnector } from '../api.connector';

class PersonalApi extends ApiConnector {
  async getFilterReqPersonal(params: IGetRequestsParams): Promise<{
    total: number;
    page_count: number;
    data: TRequest[];
  }> {
    return this.call({
      path: 'requests/filters/userRequestsByParams',
      params
    });
  }

  async getFilterOnlineReqPersonal(
    params: IGetOnlineRequestsParams
  ): Promise<TOnlineRequest[]> {
    return this.call({
      path: 'online/my-requests',
      params
    });
  }

  async getInsurancesByParams(
    params: GetInsurancesByParamsFilters
  ): Promise<TInsurancesResponse> {
    return this.call({
      path: 'insurances/filters/getInsurancesByParams',
      params
    });
  }

  async updateUserProfile(data: TUserUpdateDto) {
    return this.call({
      path: 'users/modules/personal-info',
      body: data,
      method: 'patch'
    });
  }
}

export const personalApi = new PersonalApi();

interface IGetRequestsParams {
  bank_uuid?: string;
  status_code?: string;
  dealer_uuid?: string;
  model_uuid?: string;
  brand_uuid?: string;
  date_from?: string;
  date_until?: string;
  limit?: number;
  page?: number;
}

interface IGetOnlineRequestsParams {
  bankId?: string;
  dateFrom?: string;
  dateTo?: string;
  filterType?: string;
  status?: string;
}
